export const validateESign = (fields, selectedData) => {
  let errs = {};
  for (let key in fields) {
    const _field = fields[key];

    let required = _field?.validators?.required;
   
    const {name} = _field
    if(name == 'eSign' && required){
      if(!selectedData['same_for_all']){
        errs['same_for_all'] = { err: 'Kindly Choose the signature method!' }
      } else {
        if(selectedData['signature_type']) {
          if((selectedData['signature_type'] == 'vbec' || selectedData['signature_type'] == 'electronic')){
            if(!selectedData['authentication_mode']){
              errs['authentication_mode'] = { err: 'Kindly Choose the verification type' }
            }
          }
        }
        else{
          errs['signature_type'] = { err: 'Kindly Choose the signature type' }
        }
      }
    } else if(name == 'eSign' && !required && selectedData['same_for_all']){
      if(selectedData['signature_type']) {
        if(!selectedData['authentication_mode'] && (selectedData['signature_type'] == 'vbec' || selectedData['signature_type'] == 'electronic')){
          errs['authentication_mode'] = { err: 'Kindly Choose the verification type' }
        }
    }
    else{
      errs['signature_type'] = { err: 'Kindly Choose the signature type' }
    }
    }  
  }
  return errs;
}
